import React, { ReactNode, useMemo } from 'react';
import { Box } from '@mui/material';
import styles from './Label.module.scss';
import cx from 'classnames';
import { getLabelStyle } from './label.helper';

export enum LabelVariant {
  'primary' = 'primary',
  'info' = 'info',
  'success' = 'success',
  'error' = 'error',
  'warning' = 'warning',
  'warning_secondary' = 'warning_secondary',
  'secondary' = 'secondary',
  'disabled' = 'disabled',
}

type LabelProps = {
  text?: string;
  variant?: LabelVariant;
  className?: string;
  isActive?: boolean;
  children?: ReactNode;
};

export const Label = ({
  text,
  variant,
  className,
  isActive,
  children,
}: LabelProps) => {
  const variantStyle = useMemo(() => {
    return getLabelStyle(variant, isActive);
  }, [variant, isActive]);

  return (
    <Box className={cx(styles.labelContainer, className)} style={variantStyle}>
      {text ?? ''}
      {children}
    </Box>
  );
};

export default Label;
